<template>
<div class="themes">
        <div class="container">
          <div class="themes__list animate__animated" ref="themeList">
            <ThemesListItem v-for="theme in themes" :theme="theme" />
        </div>
        </div>
</div>
</template>
<script setup lang='ts'>

/*  IMPORTS  */
import type { Competence } from '~/types/options';
import ThemesListItem from './ThemesListItem.vue';
const {themes} = defineProps<{
  themes:Competence[]
}>()
/*  VARIABLES  */

const themeList = useAnimateOnVisible('animate__fadeIn')
</script>

<style lang="scss">
    .themes{
        padding-block: 60px;
        @media screen and (max-width:550px) {
          padding-block: 20px;
        }
        &__list {
            list-style-type: none;
            padding: 0;
            display: flex;
            justify-content: center;
            gap: 4rem;
            opacity: 0;
            @media screen and (max-width:1250px){
              gap: 2rem;
            }
            @media screen and (max-width:1035px) {
              flex-wrap: wrap;
              gap: 0;
            }
        }
    }
</style>